import React, { ReactNode } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import cartoucheHomme from '../../../../img/cartouche_homme.png';
import TileInformationBlock from './TileInformationBlock';
import Button from '../../../common/Button';
import rightChevron from '../../../../img/icones/chevron_droite.svg';
import { RattachementDemand, RattachementDemandePersonne } from '../../../../network/api/types/RattachementDemand';
import rattachementDemandApi from '../../../../network/api/rattachementDemandApi';
import { formatTimestamp } from '../../../../services/dateService';
import GestionnaireTile from '../../collaboratorsManagement/components/GestionnaireTile';
import ConfirmationModal from '../../../common/modals/ConfirmationModal';
import {
  StatutEnum,
} from '../../../../network/api/types/compte/CompteProfilProProfileDetails';
import { Entity } from '../../../../network/api/types/compte/Entity';
import { notifyErrorWithMessage, toastSuccess } from '../../../common/Notification';
import { CountriesDTO } from '../../../../network/api/types/CountriesDTO';
import cartoucheFemme from '../../../../img/cartouche_femme.png';
import { getStructureName } from '../../../../services/utils';

type Props = {
  rattachementDemand: RattachementDemand,
  onUpdateList: () => void,
  entite: Entity,
  countries: CountriesDTO,
};

type State = {
  isExtended: boolean,
  personne: RattachementDemandePersonne,
  confimationModalOpen: boolean,
  modalTitleI18nKey: string,
  confirmationModalTitleI18nKey: string,
  modalSubTitleI18nKey: string,
  modalConfirmCallback: () => void,
  collaboratorType: StatutEnum,
};

class RattachementDemandes extends React.Component<Props, State> {
  state: State = {
    isExtended: false,
    personne: null,
    confimationModalOpen: false,
    modalTitleI18nKey: '',
    modalSubTitleI18nKey: '',
    confirmationModalTitleI18nKey: '',
    collaboratorType: null,
    modalConfirmCallback: () => {
    },
  };

  extandableRef = React.createRef<HTMLDivElement>();

  componentDidMount(): void {
    rattachementDemandApi.getPersonne(this.props.rattachementDemand.id)
      .then((personne) => this.setState({ personne }));
  }

  toogleIsExtended = (): void => {
    this.setState((previousState) => ({ isExtended: !previousState.isExtended }));
  };

  validateRattachement = (): void => {
    rattachementDemandApi
      .validateRattachement(this.props.rattachementDemand.id, this.state.collaboratorType)
      .then(this.props.onUpdateList)
      .then(() => toastSuccess(I18n.t('rattachement.success')))
      .catch((err) => {
        this.closeModal();
        if (typeof err.then === 'function') {
          err.then(() => notifyErrorWithMessage(I18n.t('message.ERROR')));
        }
      });
  };

  refuseRattachement = (): void => {
    rattachementDemandApi.refuse(this.props.rattachementDemand.id)
      .then(this.props.onUpdateList)
      .catch((err) => {
        this.closeModal();
        if (typeof err.then === 'function') {
          err.then(() => notifyErrorWithMessage(I18n.t('message.ERROR')));
        }
      });
  };

  getAvatar = (personne?: RattachementDemandePersonne): JSX.Element => {
    if (personne && personne.profilePicture) {
      return (<img alt="Profile pic" src={personne.profilePicture} />);
    }
    return (<img alt="Profile pic" src={personne?.civilite.toUpperCase() === 'MONSIEUR' ? cartoucheHomme : cartoucheFemme} />);
  };

  openModal = (
    modalTitleI18nKey: string,
    modalSubTitleI18nKey: string,
    confirmationModalTitleI18nKey: string,
    modalConfirmCallback: () => void,
  ): void => {
    this.setState({
      collaboratorType: null,
      modalTitleI18nKey,
      modalSubTitleI18nKey,
      confirmationModalTitleI18nKey,
      modalConfirmCallback,
      confimationModalOpen: true,
    });
  };

  closeModal = (): void => {
    this.setState({ confimationModalOpen: false });
  };

  render(): ReactNode {
    return (
      <>
        <ConfirmationModal
          titleI18nKey={this.state.modalTitleI18nKey}
          subtTitleI18nKey={this.state.modalSubTitleI18nKey}
          onConfirm={this.state.modalConfirmCallback}
          isOpen={this.state.confimationModalOpen}
          onClose={this.closeModal}
          confirmationButtonI18nKey={this.state.confirmationModalTitleI18nKey}
          confirmeDisabled={this.state.modalTitleI18nKey === 'rattachement.modal.validate.title' && !this.state.collaboratorType}
        >
          <GestionnaireTile
            member={{
              nomDaffichage: `${this.state.personne?.firstname} ${this.state.personne?.lastname}`,
              fonction: 'COLLABORATEUR',
              profilePicture: this.state.personne?.profilePicture,
            }}
          />
          {
            this.state.modalTitleI18nKey === 'rattachement.modal.validate.title' && (
              <div className="collaborator-selection">
                <Translate value="rattachement.modal.validate.precision" />
                <div className="rattachement-button-container">
                  <Button
                    onClick={() => this.setState({
                      collaboratorType: StatutEnum.SALARIE,
                    })}
                    type="fourth"
                    i18nKey="rattachement.modal.validate.salarie"
                    selected={
                      this.state.collaboratorType
                      === StatutEnum.SALARIE
                    }
                  />
                  <Button
                    onClick={() => this.setState({
                      collaboratorType: StatutEnum.NONSALARIE,
                    })}
                    type="fourth"
                    i18nKey="rattachement.modal.validate.nonSalarie"
                    selected={
                      this.state.collaboratorType
                      === StatutEnum.NONSALARIE
                    }

                  />
                </div>
              </div>
            )
          }
        </ConfirmationModal>
        <div className="rattachement-tile">
          <div className="rattachement-tile-title">
            {`${getStructureName(this.props.entite)}` }
          </div>
          <div>
            <div className="rattachement-tile-header">
              <div className="picture">
                {this.getAvatar(this.state.personne)}
              </div>
              <div>
                <div className="personne-name">
                  {this.state.personne?.firstname}
                  <br />
                  {this.state.personne?.lastname}
                </div>
                <div className="caption personne-role">
                  COLLABORATEUR
                </div>
              </div>
            </div>
            {
              this.props.rattachementDemand.refusedDate && (
                <div className="refusal-message">
                  <Translate
                    value="rattachement.tile.refusedBy"
                    date={formatTimestamp(this.props.rattachementDemand.refusedDate)}
                    name={this.props.rattachementDemand.refusedBy}
                  />
                </div>
              )
            }
          </div>
          {
            this.props.rattachementDemand.refusedDate && (
              <div className="chevron-button-container">
                <button type="button" onClick={this.toogleIsExtended}>
                  <img
                    className={`chevron ${this.state.isExtended ? 'face-up' : 'face-bottom'}`}
                    src={rightChevron}
                    alt=""
                  />
                </button>
              </div>
            )
          }
          <div
            className={this.props.rattachementDemand.refusedDate ? `rattachement-tile-content ${!this.state.isExtended && 'hide-content'}` : ''}
            style={
              this.props.rattachementDemand.refusedDate
              && {
                height: this.state.isExtended
                  ? this.extandableRef.current.getBoundingClientRect().height
                  : 0,
              }
            }
          >
            <div ref={this.extandableRef}>
              <div className="rattachement-tile-information-block">
                <div className="information-line">
                  <TileInformationBlock
                    titleKey="PERSONAL_INFORMATION.BIRTH_NAME"
                    value={this.state.personne?.birthName}
                  />
                  <TileInformationBlock
                    titleKey="PERSONAL_INFORMATION.BIRTH_VILLE"
                    value={this.state.personne?.birthCity}
                  />
                </div>
                <div className="information-line">
                  <TileInformationBlock
                    titleKey="PERSONAL_INFORMATION.BIRTH_DATE"
                    value={this.state.personne?.birthDate}
                  />
                  <TileInformationBlock
                    titleKey="PERSONAL_INFORMATION.BIRTH_COUNTRY"
                    value={this.props.countries.countries?.filter((c) =>
                      c.code === this.state.personne?.birthCountry)[0]?.nom}
                  />
                </div>
              </div>
              <div className="rattachement-button-container">
                {
                  !this.props.rattachementDemand.refusedDate && (
                    <Button
                      onClick={() =>
                        this.openModal(
                          'rattachement.modal.refuse.title',
                          'rattachement.modal.refuse.subTitle',
                          'rattachement.tile.refuse',
                          this.refuseRattachement,
                        )}
                      type="third"
                      i18nKey="rattachement.tile.refuse"
                    />
                  )
                }
                <Button
                  onClick={() =>
                    this.openModal(
                      'rattachement.modal.validate.title',
                      'rattachement.modal.validate.subTitle',
                      'rattachement.tile.rattacher',

                      this.validateRattachement,
                    )}
                  type={this.props.rattachementDemand.refusedDate ? 'secondary' : 'primary'}
                  i18nKey="rattachement.tile.rattacher"
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default RattachementDemandes;
